export const enum KnowledgeFeedsEventSection {
  staticFeed = 'staticFeed',
  mixedContentFeed = 'mixedContentFeed',
  videoFeed = 'videoFeed',
}

export const enum KnowledgeFeedEvent {
  ClickFeedCarouselLeft = 'clickFeedCarouselLeft',
  ClickFeedCarouselRight = 'clickFeedCarouselRight',
  ClickFeedViewAll = 'clickFeedViewAll',
  ClickFeedTile = 'clickFeedTile',
  CarouselImpression = 'carouselImpression',
  FeedCardImpression = 'feedCardImpression',
}
